import React from 'react';
import cx from 'classnames';
import canUseDOM from '../../../common/canUseDom';


class Submenu extends React.Component {

  static propTypes = {
    mobile: React.PropTypes.bool,
    openRef: React.PropTypes.string
  }

  constructor(props) {
    super(props);
  }

  getMenuClasses(menu) {
    return cx({
      'dropdown-menu': this.props.mobile ? false : true,
      'active': this.props.openRef === menu,
    });
  }

  exitLink(path) {
    let destination = canUseDOM ? window.location.pathname : '/';
    return `${path}?destination=${destination}`;
  }


}


export default Submenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/Submenu.js